/*
 * Copyright (c) 2024 - 2025 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { BaseCallback } from './base-callback.js';
/**
 * @class - Represents a callback used to complete and package up device and behavioral data.
 */
export class PingOneProtectEvaluationCallback extends BaseCallback {
    payload;
    /**
     * @param payload The raw payload returned by OpenAM
     */
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    /**
     * Gets the callback's pauseBehavioralData value.
     * @returns {boolean}
     */
    getPauseBehavioralData() {
        return this.getOutputByName('pauseBehavioralData', false);
    }
    /**
     * @method setData - Set the result of data collection
     * @param {string} data - Data from calling pingProtect.get()
     * @returns {void}
     */
    setData(data) {
        this.setInputValue(data, /signals/);
    }
    /**
     * @method setClientError - Set the client error message
     * @param {string} errorMessage - Error message
     * @returns {void}
     */
    setClientError(errorMessage) {
        this.setInputValue(errorMessage, /clientError/);
    }
}
/**
  * Example of callback:
{
  "type": "PingOneProtectEvaluationCallback",
  "output": [
    {
      "name": "pauseBehavioralData",
      "value": true
    }
  ],
  "input": [
    {
      "name": "IDToken1signals",
      "value": ""
    },
    {
      "name": "IDToken1clientError",
      "value": ""
    }
  ]
}
*/
